import { Component, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { ProfileService } from '../common/core/auth/profile.service';
import { I18NService } from '../common/core/i18n/i18n.service';
import { WelcomeDialogDataService } from './welcome-dialog-data.service';
import { DIALOG_VERSION, DIALOG_VERSION_KEY } from './dialog-version';
import { WindowRef } from '../common/core/domain/window-ref';
import { AdminuiDialogComponent } from '../common/components/dialog/adminui-dialog.component';
import { A11yModule } from '@angular/cdk/a11y';

@Component({
    selector: 'adminui-welcome-dialog',
    imports: [AdminuiDialogComponent, A11yModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './welcome-dialog.component.html'
})
export class WelcomeDialogComponent implements OnInit {
  readonly translationIndex = 'welcomeDialog';

  private readonly profileService = inject(ProfileService);
  private readonly i18nService = inject(I18NService);
  private readonly welcomeDialogDataService = inject(WelcomeDialogDataService);
  private readonly windowRef = inject(WindowRef);

  readonly message = signal<{ [key: string]: string; }>({});
  readonly username = signal('');

  ngOnInit(): void {
    this.message.set({ ...this.i18nService.messages[this.translationIndex] });
    this.username.set(this.profileService.profile.given_name);
  }

  close(): void {
    localStorage.setItem(DIALOG_VERSION_KEY, DIALOG_VERSION);
    this.welcomeDialogDataService.closeDialog();
  }

  ok(): void {
    let url = "https://docs.vismasoftware.no/admin/";
    const locale = this.profileService.profile.locale;
    switch (locale) {
      case 'nb-NO': url = "https://docs.vismasoftware.no/no/admin/";
        break;
      case 'sv-SE': url = "https://docs.vismasoftware.no/sv/admin/";
        break;
    }
    this.windowRef.open(url, '_blank');
    localStorage.setItem(DIALOG_VERSION_KEY, DIALOG_VERSION);
    this.welcomeDialogDataService.closeDialog();
  }
}
